/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_McpInputs */

const en_mk_foot_mcp = /** @type {(inputs: Mk_Foot_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP server`)
};

const id_mk_foot_mcp = /** @type {(inputs: Mk_Foot_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Server MCP`)
};

/**
* | output |
* | --- |
* | "MCP server" |
*
* @param {Mk_Foot_McpInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_mcp = /** @type {((inputs?: Mk_Foot_McpInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_McpInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_mcp(inputs)
	return en_mk_foot_mcp(inputs)
});